import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Receipt } from 'lucide-react';
import { PageHeader, Section } from '../../components/page.tsx';
import { EmptyState, Panel, Splash } from '../../components/ui.tsx';
import { useInvoices } from '../../lib/invoices.ts';
import { InvoiceList, YearSwitch } from '../shared/Invoices.tsx';
import { useTenant } from './TenantShell.tsx';

/** Vuokralaisen laskut: kuukausittain tila ja lasku avattavissa. */
export function TenantInvoicesPage() {
  const { t } = useTranslation();
  const { current, isLoading: shellLoading } = useTenant();
  const [year, setYear] = useState(new Date().getFullYear());
  const { data: invoices, isLoading } = useInvoices(current?.id, year);

  if (shellLoading || (current && isLoading)) return <Splash />;
  const list = invoices ?? [];
  return (
    <>
      <PageHeader title={t('nav.invoices')} />
      <Section
        title={t('invoices.tenantTitle')}
        action={<YearSwitch year={year} onChange={setYear} />}
      >
        {!current || list.length === 0 ? (
          <EmptyState
            icon={<Receipt size={22} />}
            title={t('invoices.emptyYear', { year })}
            text={t('invoices.tenantEmpty')}
          />
        ) : (
          <Panel>
            <InvoiceList
              invoices={list}
              propertyId={current.id}
              canReport={current.settings.tenantPaymentReports}
            />
          </Panel>
        )}
      </Section>
    </>
  );
}
